module.exports = __webpack_public_path__ + "static/media/orange_animal_insects_6.16f43051.png";